import React from 'react';
import { useOrderExtraction } from '../../contexts/OrderExtractionContext';
import './SelectedProducts.css';

const SelectedProducts = ({ onSubmitOrder }) => {
  const { state, actions } = useOrderExtraction();
  const { selectedProducts } = state;
  const handleRemoveSelection = (itemIndex) => {
    actions.removeSelectedProduct(itemIndex);
  };

  const handleClearAllSelections = () => {
    actions.clearSelectedProducts();
  };

  const handleSubmitOrder = () => {
    if (onSubmitOrder) {
      onSubmitOrder();
    }
  };

  if (!selectedProducts || Object.keys(selectedProducts).length === 0) {
    return (
      <div className="selected-products">
        <div className="selected-products-header">
          <h3>Produtos Selecionados</h3>
        </div>
        <div className="empty-selections">
          <div className="empty-icon">🛒</div>
          <p>Nenhum produto selecionado</p>
          <span>Selecione candidatos nos itens extraídos para vê-los aqui</span>
        </div>
      </div>
    );
  }

  const selectedCount = Object.keys(selectedProducts).length;
  const totalItems = Object.values(selectedProducts).length;

  return (
    <div className="selected-products">
      <div className="selected-products-header">
        <h3>Produtos Selecionados</h3>
        <div className="selections-count">
          {selectedCount} selecionado{selectedCount !== 1 ? 's' : ''}
        </div>
      </div>
      
      <div className="selected-products-content">
        <div className="selected-products-list">
          {Object.entries(selectedProducts).map(([itemIndex, selection]) => {
            const itemIndexNum = parseInt(itemIndex);
            return (
              <div key={itemIndex} className="selected-product-card">
                <div className="selected-product-header">
                  <span className="item-number">Item {itemIndexNum + 1}</span>
                  <button 
                    className="remove-selection"
                    onClick={() => handleRemoveSelection(itemIndexNum)}
                    title="Remover seleção"
                  >
                    ✕
                  </button>
                </div>
                
                <div className="selected-product-details">
                  <div className="product-info">
                    <div className="product-code">
                      {selection.productCode}
                    </div>
                    <div className="product-description">
                      {selection.productDescription}
                    </div>
                  </div>
                  
                  <div className="product-quantity">
                    <span className="quantity-label">Quantidade:</span>
                    <span className="quantity-value">
                      {selection.quantity || 0} {selection.unityOfMeasure || 'UN'}
                    </span>
                  </div>
                  
                  {selection.observation && (
                    <div className="product-observation">
                      <span className="observation-label">Observação:</span>
                      <span className="observation-value">{selection.observation}</span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        
        <div className="selected-products-actions">
          <button 
            className="btn btn-secondary"
            onClick={handleClearAllSelections}
          >
            Limpar Todas as Seleções
          </button>
          <button 
            className="btn btn-primary btn-submit"
            onClick={handleSubmitOrder}
          >
            Criar Pedido no ERP
          </button>
        </div>
        
        <div className="order-summary">
          <h4>Resumo do Pedido</h4>
          <div className="summary-stats">
            <div className="stat-item">
              <span className="stat-label">Total de Itens:</span>
              <span className="stat-value">{totalItems}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Produtos Selecionados:</span>
              <span className="stat-value">{selectedCount}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedProducts;
